import { parseLocalISODate, safeFormatDate } from '@/lib/dateUtils';

interface DateCellProps {
  value: unknown;
}

/**
 * Displays a calendar day as `MMM dd, yyyy` text ("Nov 04, 2026") — the same
 * format and font as the read-only date columns of the other grids, which
 * render `safeFormatDate(value, 'MMM dd, yyyy')` themselves.
 *
 * The month is spelled out on purpose. An earlier numeric text display
 * (`toLocaleDateString`) could order day/month differently from the native
 * `<input type="date">` editor (whose mask follows the OS regional format, not
 * readable from JS), so users edited the month thinking it was the day; a
 * June 2026 fix then painted the resting cell with a read-only native input.
 * A spelled-out month cannot be read in the wrong order, and the editor's
 * picker shows its own mask, so the two states can no longer be confused.
 *
 * Non-ISO values (e.g. `timestamptz` strings) fall back to the raw text.
 */
export function DateCell({ value }: DateCellProps) {
  if (value == null || value === '') return null;
  const raw = String(value);
  if (!parseLocalISODate(raw)) return <span>{raw}</span>;
  return <span>{safeFormatDate(raw, 'MMM dd, yyyy', raw)}</span>;
}
